
<style>
.list {
  list-style: none;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.list li {
  padding: 12px 14px;
  font-size: 16px;
}
.list li a {
  text-decoration: none;
  color: rgb(255, 255, 255);
}
.main-logo .main-logo-img {
  width: 50px;
}
.main-div{
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1030;
  transition: all 0.8s;
}
.none-menu-bar{display:none;}
.none-menu-bar p{
  width: 40px;
    height: 40px;
    border: 1px solid white;
    text-align: center;
    line-height: 49.5px;
    border-radius: 5px;
}
.main-bg-containt{
  text-align: center;
  z-index: 1;
  position: relative;
  padding-top:60px !important;
}
.none-menu-bar p i{color: white;
    font-size: 29px;}
.main-bg-containt h1 {
  color: white;
  font-size: 65px;
  margin-bottom: 10px;
}
.main-bg-containt p span::before {
  content: "";
  color: #27e278;
  animation: profile 5s infinite;
  margin: 0 0 0 6px;
}
@keyframes profile {
  0% {
    content: "UI/UX Designer";
  }
  50% {
    content: "Web Developer";
  }
  100% {
    content: "UI/UX Designer";
  }
}
.main-bg-containt p {
  font-size: 27px;
  font-weight: 400;
  color: white;
  margin-bottom: 20px;
}
.main-bg {
  background: url(../assets/zia-syed-gOq27RHoL3s-unsplash.jpg) center center / cover;
  position: relative;
  padding: 100px 0;
  min-height: 100vh;
}
.wave_shape {
  position: absolute;
  bottom:0px;
  left: 0;
  right: 0;
}

.main-bg-details p {
  color: white;
  width: 52%;
  margin: 0 auto;
  margin-bottom: 20px;
  font-size: 17px;
}
.downlord {
  border-radius: 0;
  background: #27e278;
  font-size: 15px; 
  color: white;
  margin-right: 10px;
  margin: 14px 10px 10px 0;
  padding: 23px 15px;
}
.Touch {
  border-radius: 0;
  background: white;
  font-size: 15px;
  color: #27e278;
  margin-right: 10px;
  margin: 14px 0px 10px 10px;
  padding: 23px 15px;
}
.fixed_bg {
  background-attachment: fixed !important;
}
.main-bg::before {
  bottom: 0;
  content: "";
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  z-index: 0;
  background-color: rgba(12, 14, 39, 0.8);
}
.ap-details {
  background: #252740;
  padding: 70px 0;
}
.ap-img-ap {
  width: 90%;
  z-index: 1;
}
.ap-img {
  position: relative;
}
.ap-img-border {
  position: absolute;
  border: 8px solid white;
  top: 35px;
  bottom: -36px;
  left: 30px;
  right: 5px;
  z-index: 0;
}
.about {
  border-bottom: 1px solid white;
}
.about h3 {
  color: white;
  font-size: 40px;
  font-weight: normal;
  margin-bottom: 3px;
}
.about p {
  color: white;
  font-size: 17px;
  padding-bottom: 15px;
}
.basic-info h3 {
  color: white;
  font-size: 28px;
  font-weight: normal;
  margin-bottom: 3px;
  padding-top: 15px;
}
.add {
  list-style-type: none;
}
.add li {
  color: white;
  font-size: 18px;
  padding: 6px 0;
  display: flex;
  align-items: center;
}
.add li p {
  width: 125px;
}
.skills {
  padding: 50px 0;
  background: #121833;
}
.skills-heading {
  text-align: center;
}
.skills-heading h2 {
  color: white;
  font-size: 38px;
  font-weight: 500;
}
.skills-heading p {
  padding-top: 8px;
  width: 60%;
  margin: auto;
  color: white;
  font-size: 17px;
  padding-bottom: 14px;
}
.main-progres{
  padding: 16px;
  background: #41465c;
}
.design .design-heading{display: flex;
  align-items: center;
  justify-content: space-between;
  list-style: none;
  margin-bottom: 20px;
}
.design-heading li a{
  color: white;
  text-decoration: none;
  font-size: 18px;
}
.nav-header{
  background: rgb(0, 0, 0);
}
.progres-bar-s{
  width: 100%;
  position: relative;
  height: 3px;
  background: #dddddd;
  border-radius: 100px;
}
.progres-bar-green{
  position: absolute;
  width: 85%;
  height: 3px;
  background: #27E278;
  border-radius: 100px;
}
.services{
  background:#252740;
  padding: 50px 0;
}
.services-icon{
  text-align: center;
  border: 1px solid white;
  padding: 18px;
  transition: all 0.5s;
}
.services-icon a{
  color: #27e278;
  font-size: 41px;
}
.services-icon h4{
  color: white;
  padding-bottom: 9px;
  font-size: 23px;
}
.services-icon p{
  color: white;
  line-height: 18px;
  font-size: 17px;
}
.services-icon:hover{
  background:rgba(255,255,255,0.1);
  border-color:rgba(255,255,255,0.1);
}
.claint-s{
  background: url(../assets/bg-img.jpg) center center / cover;
  padding: 50px 0;
  position: relative;
}
.claint-s::before {
  bottom: 0;
  content: "";
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  z-index: 0;
  background-color: rgba(12, 14, 39, 0.8);
}
.projects-completed{
  position: relative;
  text-align: center;
}
.projects-completed a{
  color: white;
  font-size: 40px;
}
.projects-completed h3{
  font-size: 28px;
  color: white;
}
.projects-completed p{
  color: white;
  font-size: 12px;
}
.myportfolio{
  background:#252740;
  padding: 50px 0;
}
.img-head-p{
  list-style: none;
  display: flex;
  align-items: center;
  justify-content: center;
}
.img-head-p li{
  color: white;
  padding: 5px 20px;
  transition: all 0.8s;
  border-bottom:1px solid transparent;
}
.img-head-p li:hover{
  border-bottom:1px solid lime;color: lime;
}
.myresume{
  background:#121833;
  padding:50px 0;
}
.education-head{
  display: flex;
  align-items: center;
}
.education-head i{
  color: white;
  height: 40px;
  width: 40px;
  background: #27e278;
  border-radius: 100px;
  text-align: center;
  line-height: 40px;
  margin-right: 15px;
}
.education-head h4{
  color: white;
  font-weight: 400;
}
.education-details{
  border-left:1px solid white;
  margin-left:20px;
}
.education-main-details{
  padding: 17px 0 0 25px;
  position: relative;
}
.education-main-details::before{
  content: "";
  position: absolute;
  top: 38px;
  left: -7.5px;
  height: 14px;
  width: 14px;
  background: #27e178a2;
  border-radius: 100px;
}
input, textarea{color: white;}
.education-main-details::after{
  content: "";
  position: absolute;
  top: 41px;
  left: -5px;
  height: 8px;
  width: 8px;
  background: #27e178;
  border-radius: 100px;
}
.education-main-details-p{
  padding: 20px;
  background-color: rgba(255,255,255,0.1);
  position: relative;
}
.education-main-details-p::after{
  content: "";
  position: absolute;
  width: 0;
  height: 0;
  border-top: 10px solid transparent;
  border-right: 15px solid #2a3048;
  border-bottom: 10px solid transparent;
  top: 18px;
  left: -15px;
}
.SecondarySchool{
  border-bottom: 1px solid white;
}
.SecondarySchool p{
  color: #27e278;
  font-size: 17px;
}
.SecondarySchool p span{
  color:white;
}
.SecondarySchool h3{
  color: white;
  font-size: 25px;
  font-weight: normal;
  padding: 5px 0;
}
.High-School p{
  padding: 7px 0 0 0;
  font-size: 16px;
  color: white;
}
.Testimonials{
  padding: 50px 0;
  background: #252740;
}

.VueCarousel-slide {
  height:100px;
  color:#FFF;
  background:#59ecff;
  display: flex;
  align-items: center;
  justify-content: center;
  border-right:1px solid #FFF;
  box-sizing:border-box;
  font-size:12px;
  text-align:center;
}
.clients-pic .v-img{width:50px;}
.clients-name-details{background: #3b3d53;
    padding: 18px;}
.clients-img-c{display: flex;
    align-items: center;}
.clients-name-fill{margin-left: 14px;}
.clients-name-fill h4 {
    color: white;
    font-size: 20px;
    font-weight: 400;
}
.clients-name-fill p{font-size: 12px;
    font-style: italic;
    color: #27e278;}
.c-details p {
    color: white;
    font-size: 15px;
    padding-top: 13px;
}
.Blog{background:#121833;padding:50px 0;}
.card-main {
    background: #2a2f48;
    padding: 12px;
}
.ui-ux-heading h5 a {
    color: #27e278;
    text-decoration: none;
    padding: 8px 0;
}
.ui-ux-heading{padding: 8px 0 0 0;}
.ui-ux-heading p {
    color: white;
    font-size: 21px;
    font-weight: 500;
    padding: 4px 0 0 0;
}
.calender p a {
    text-decoration: none;
    color: white;
    font-size: 12px;
}
.calender span {
    color: white;
    font-size: 11px;
}
.calender p {
    color: white;
    font-size: 13px;
    padding: 6px 0;
    font-weight: 300;
}
.readmore h5 a {
    text-decoration: none;
    color: white;
    font-size: 16px;
    font-weight: 400;
}
.contact-me{
    padding:50px 0;
    background:#252740;
}
.input-tag input{
    border: 1px solid white;
    padding: 4px 0 4px 6px;
    width: 100%;
    height: 45px;
}
.input-tag input::placeholder{
    font-size:14px; 
    color: white;
}
.massage-text textarea{
    width: 100%;
    border: 1px solid white;
    padding: 0px 6px 0 6px;height: 118px;
}
.massage-text textarea::placeholder{
    font-size:14px; color: white;
}
.submit-button .v-btn{
    width: 100%;
    border-radius: 0;
    padding: 0px 0px 0 0px;
    background: #27e278;
    color: white;
    font-size: 12px;
    font-size: 15px;
    height: 41px;
}
.location{
    text-align: center;
    margin-top: 20px;
  }
.location i{
    font-size: 45px;
    color: #27e278;}
.location h4{font-size: 15px;
    padding: 5px 0;
    color: white;
    font-weight: normal;}
.location p{color: white;
    font-size: 13px;
    font-weight: 400;}
.footer{
    background:#121833;
    padding:100px 0 30px 0;
    position: relative;
}
.footer::before{
  content: "";
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    background-image: url(../assets/shap-2.png);
    height: 100px;
    background-position: top center;
    background-repeat: no-repeat;
    width: 100%;
}
.footer-logo .v-img{
    width: 50px;
    margin:0 auto;
}
.new p{
    color: white;
    text-align: center;
    padding: 10px 0;
}
.footer-input input {
    background: white;
    padding: 0px 0 0 7px;
    height: 39px;
    width: 500px;
}
.footer-input {
    position: relative;
    text-align: center;
}
.footer-input .v-btn {
    border-radius: 0;
    font-size: 11px;
    color: white;
    background: #27e278;
    position: absolute;
    top: 1px;
    right: 339px;
    height: 36px;
}
.footer-list{width: 70%;
    margin: 20px auto;
    border-top: 1px solid white;
    border-bottom: 1px solid white;}
.f-list{list-style: none;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 9px 0px;}
.f-list li{padding: 0 22px;}
.f-list li a{text-decoration: none;
    color: white;
    font-size: 13px;}
.f-list li a:hover{color:#27e278;}
.f-social{list-style: none;
    display: flex;
    align-items: center;
    justify-content: center;}
.f-social li a{color: white;text-decoration: none;}
.f-social li a:hover{color:#27e278;}
.f-social li{padding: 0 10px;}
.copy-footer{background:#0c0e27; padding: 20px 0;}
.copy p{text-align: center;color: white;font-size: 12px;font-weight: lighter;}
.copy p a{text-decoration: none;color:#27e278;}
.portfolio-img-p{margin-top:20px;}
.v-main__wrap{overflow: hidden;}
.none-header{display: none;}
@media only screen and (max-width:1024px){
 /* .wave_shape{bottom: -5px;} */
 .about h3{font-size:35px;}
 .about p{font-size:14px;}
 .basic-info h3{font-size: 24px;}
 .add li{font-size:14px;padding: 3px 0;}
 .add li p {width: 97px;}
 .services-icon p{font-size:14px;}
 .services-icon h4{padding-bottom: 2px;
    font-size: 22px;}
  .input-tag input{height: 39px;}
  .footer-input .v-btn{right:190px;}
  .list li{padding: 12px 9px;font-size: 12px;}
}
@media only screen and (max-width:991px){
.main-bg-containt h1{font-size: 56px;margin-bottom: 0;}
.main-bg-containt p{font-size: 23px;}
.main-bg-details p{font-size: 15px;}
.downlord, .Touch{font-size: 13px;padding: 19px 15px;}
/* .wave_shape {bottom: -8px;} */
.services-icon h4{font-size: 19px;}
.services-icon p {font-size: 13px;font-weight: 100;}
.SecondarySchool h3{font-size:20px;}
.High-School p{font-size: 14px;}
.c-details p{font-size: 13px;}
.ui-ux-heading p{font-size:18px;}
.massage-text textarea{height:107px;}
.submit-button .v-btn{height:35px;}
.design-heading li a{font-size: 15px;}
}
@media only screen and (max-width:768px){
  .main-logo .v-img{margin: 0 auto;}
  .list{justify-content:center;}
  /* .wave_shape {bottom: -28px;} */
  .footer-input .v-btn {right: 124px;}
  .f-list li {padding: 0 16px;}
  .list li{padding: 0 9px    ;}
  .none-header{background: black;width: 203px;display:block;position: fixed;z-index: 999999;top: 0px;height:100%;}
  .logo-img-none{padding-bottom: 12px;}
  .logo-img-none .v-responsive{margin:0 auto;}
  .logo-img-none .v-img{width:50px;}
  .list-menu{list-style: none;}
  .list-menu li{padding: 6px 8px;
    border-top: 1px solid white;}
    .list-menu li:last-child{border-bottom:1px solid white;}
  .list-menu li a{color: white;
    text-decoration: none;}
    .list{display:none;}
    .none-menu-bar{display:block;}
    .main-logo-menu-bar{display:flex; align-items:center; justify-content:space-between;}
}
@media only screen and (max-width: 575px){
  .main-bg-containt h1 {font-size: 46px;margin-bottom: 0;}
  /* .wave_shape {bottom: -46px;} */
  .ap-protfolio{margin-top: 32px;}
  .about p {font-size: 17px;font-weight: lighter;}
  .add li {font-size: 17px;}
  .add li p {width: 116px;}
  .footer-input .v-btn{right: 27px;}
  .f-list li {padding: 0 7px;}
  .skills-heading h2{font-size: 34px;}
  .skills-heading p{font-weight: 300;}
  .skills{padding: 21px 0;}
  .none{display:none;}
  .footer-input input{width:100%;}
  .footer-input .v-btn{right:0;}
}
@media only screen and (max-width: 425px){
  /* .wave_shape{bottom: -60px;} */
  .ap-details{padding: 29px 0;}
  .skills-heading p{width: 100%;}
  .none{display:none;}
  .contact-me{padding:0 0;}
  .footer-input input{width: 399px;}
  .footer-input .v-btn{right:3px;}
  .footer-list{width:100%;}
  .copy-footer{padding:3px 0;}
  .img-head-p li{padding:5px 13px}
}
@media only screen and (max-width: 375px){
  /* .wave_shape {bottom: -64px;} */
  .footer-input input {width: 349px;}
  .f-list li{padding: 0 5px;}
  .main-bg-details p{width:100%;}
  .img-head-p li{padding:5px 4px}
  .f-list li{padding: 0 3px;}
  
}
@media only screen and (max-width: 320px){
  /* .wave_shape {bottom: -69px;} */
  .about h3 {font-size: 27px;}
  .about p {font-size: 14px;}
  .skills-heading h2 {font-size: 25px;}
  .skills-heading p{font-size: 15px;}
  .footer-input input {width: 296px;}
  .footer-list{display: none;}
  .social{margin-top:15px;}
  .main-bg-details p{width:100%;}
}


</style>




<template>
  <div class="main-div" id="home" v-click-outside="optionclose">
    <v-container>
      <v-row class="align-center">
        <v-col md="3" sm="12" cols="12">
          <div class="main-logo-menu-bar">
          <div class="main-logo">
            <v-img src="../assets/logo-img.png" class="main-logo-img"></v-img>
          </div>
          <div class="none-menu-bar" @click="optionone">
            <div class="none-menu-bar">
            <p><i class="fas fa-bars"></i></p>
          </div>
          </div>
          </div>
        </v-col>
        <v-col md="9" sm="12">
          <div class="main-list">
            <v-ul class="list">
              <li><a href="#home">HOME</a></li>
              <li><a href="#about">ABOUT</a></li>
              <li><a href="#service">SERVICES</a></li>
              <li><a href="#portfolio">PORTFOLIO</a></li>
              <li><a href="#resume">EXPERIENCE</a></li>
              <li><a href="#Blog">BLOG</a></li>
              <li><a href="#contact-me">CONTACT</a></li>
              <li>
                <a href="#">PAGES <i class="fas fa-chevron-down"></i></a>
              </li>
            </v-ul>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
  <div class="none-header" v-if="display">
    <v-container>
       <v-row>
          <v-col md="12">
            <div class="logo-img-none">
              <v-img src="../assets/logo-img.png"></v-img>
            </div>
            <div class="main-list responsive-header">
                <v-ul class="list-menu">
                  <li><a href="#home">HOME</a></li>
                  <li><a href="#about">ABOUT</a></li>
                  <li><a href="#service">SERVICES</a></li>
                  <li><a href="#portfolio">PORTFOLIO</a></li>
                  <li><a href="#resume">EXPERIENCE</a></li>
                  <li><a href="#Blog">BLOG</a></li>
                  <li><a href="#contact-me">CONTACT</a></li>
                  <li>
                    <a href="#">PAGES <i class="fas fa-chevron-down"></i></a>
                  </li>
                </v-ul>  
            </div>
          </v-col>
        </v-row>
    </v-container>
  </div>

  <div class="main-bg fixed_bg overlay_bg_blue_80">
    <v-container>
      <v-row>
        
        <v-col md="12" sm="12" cols="12">
          <div class="main-bg-containt">
            <h1>I'm Aniket Patel</h1>
            <p>I'm a Freelance<span></span></p>
            <div class="main-bg-details">
              <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                eiusmod tempor incididunt ut labore.
              </p>
            </div>
            <div class="main-bg-button">
              <v-btn class="downlord">Downlord CV</v-btn>
              <v-btn class="Touch">Get In Touch</v-btn>
            </div>
          </div>
        </v-col>
        <v-col md="12" sm="12">
          <div class="wave_shape">
            <v-img src="../assets/shap.png"></v-img>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>

  <section class="ap-details" id="about">
    <v-container>
      <v-row>
        <v-col md="5" sm="5" cols="12">
          <div class="ap-img">
            <v-img src="../assets/aniket.jpg" class="ap-img-ap"></v-img>
            <div class="ap-img-border"></div>
          </div>
        </v-col>
        <v-col md="7" sm="7" cols="12">
          <div class="ap-protfolio">
            <div class="about">
              <h3>About Me</h3>
              <p>
                Nam eget neque pellentesque efficitur neque at, ornare orci.
                Vestibulum ligula orci volutpat id aliquet eget, consectetur
                eget ante. Duis pharetra for nec rhoncus felis sagittis nec amet
                ultricies lorem.
              </p>
              <p>
                All the Lorem Ipsum generators on the Internet tend to repeat
                predefined chunks as necessary.Iipsum dolor sit amet consectetur
                adipiscing elitllus blandit massa enim.
              </p>
            </div>
            <div class="basic-info">
              <h3>Basic Info</h3>
              <v-ul class="add">
                <li>
                  <p>Date Of Birth :</p>
                  8 October 1998
                </li>
                <li>
                  <p>Phone No :</p>
                  +919638123369
                </li>
                <li>
                  <p>Email :</p>
                  annupatel7775@gmail.com
                </li>
                <li>
                  <p>Address :</p>
                  Rander, Surat, Gujarat
                </li>
                <li>
                  <p>Website :</p>
                  www.mywebsite.com
                </li>
                <li>
                  <p>Job :</p>
                  Logix Built Infotech
                </li>
              </v-ul>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </section>

  <section class="skills" id="skills">
    <v-container>
      <v-row>
        <v-col md="12" sm="12" cols="12">
          <div class="skills-heading">
            <h2>My Skills</h2>
            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus
              blandit massa enim. Nullam id varius nunc id varius nunc.
            </p>
          </div>
        </v-col>
        <v-col md="4" sm="6" cols="12">
          <div class="main-progres">
            <div class="design">
              <v-ul class="design-heading">
                <li><a href="#">UX/UI Design</a></li>
                <li><a href="#">80%</a></li>
              </v-ul>
              <div class="progres-bar-s">
                <span class="progres-bar-green" style="width: 80%;"></span>
              </div>
            </div>
          </div>
        </v-col>    
        <v-col md="4" sm="6" cols="12">
          <div class="main-progres">
            <div class="design">
              <v-ul class="design-heading">
                <li><a href="#">Development</a></li>
                <li><a href="#">90%</a></li>
              </v-ul>
              <div class="progres-bar-s">
                <span class="progres-bar-green" style="width: 90%;"></span>
              </div>
            </div>
          </div>
        </v-col>
        <v-col md="4" sm="6" cols="12">
          <div class="main-progres">
            <div class="design">
              <v-ul class="design-heading">
                <li><a href="#">Photography</a></li>
                <li><a href="#">70%</a></li>
              </v-ul>
              <div class="progres-bar-s">
                <span class="progres-bar-green" style="width: 70%;"></span>
              </div>
            </div>
          </div>
        </v-col>
        <v-col md="4" sm="6" cols="12">
          <div class="main-progres">
            <div class="design">
              <v-ul class="design-heading">
                <li><a href="#">Marketing</a></li>
                <li><a href="#">75%</a></li>
              </v-ul>
              <div class="progres-bar-s">
                <span class="progres-bar-green" style="width: 75%;"></span>
              </div>
            </div>
          </div>
        </v-col>
        <v-col md="4" sm="6" cols="12">
          <div class="main-progres">
            <div class="design">
              <v-ul class="design-heading">
                <li><a href="#">Bussiness Strategy</a></li>
                <li><a href="#">80%</a></li>
              </v-ul>
              <div class="progres-bar-s">
                <span class="progres-bar-green" style="width: 80%;"></span>
              </div>
            </div>
          </div>
        </v-col>
        <v-col md="4" sm="6" cols="12">
          <div class="main-progres">
            <div class="design">
              <v-ul class="design-heading">
                <li><a href="#">App Design</a></li>
                <li><a href="#">85%</a></li>
              </v-ul>
              <div class="progres-bar-s">
                <span class="progres-bar-green" style="width: 85%;"></span>
              </div>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </section>

  <section class="services" id="service">
    <v-container>
      <v-row>
        <v-col md="12" sm="12" cols="12">
          <div class="skills-heading">
            <h2>Awesome Services</h2>
            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus
              blandit massa enim. Nullam id varius nunc id varius nunc.
            </p>
          </div>
        </v-col>
        <v-col md="4" sm="6" cols="12">
          <div class="service-details">
            <div class="services-icon">
              <a href="#"><i class="fas fa-image"></i></a>
              <h4>Graphic Design</h4>
              <p>There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration</p>
            </div>
          </div>
        </v-col>
        <v-col md="4" sm="6" cols="12">
           <div class="service-details">
            <div class="services-icon">
              <a href="#"><i class="fas fa-video"></i></a>
              <h4>Digital Marketing</h4>
              <p>There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration</p>
            </div>
          </div>
        </v-col>
        <v-col md="4" sm="6" cols="12">
           <div class="service-details">
            <div class="services-icon">
              <a href="#"><i class="fas fa-crown"></i></a>
              <h4>Branding</h4>
              <p>There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration</p>
            </div>
          </div>
        </v-col>
        <v-col md="4" sm="6" cols="12">
           <div class="service-details">
            <div class="services-icon">
              <a href="#"><i class="fas fa-lightbulb"></i></a>
              <h4>Development</h4>
              <p>There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration</p>
            </div>
          </div>
        </v-col>
        <v-col md="4" sm="6" cols="12">
           <div class="service-details">
            <div class="services-icon">
              <a href="#"><i class="fas fa-mobile"></i></a>
              <h4>Mobile Application</h4>
              <p>There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration</p>
            </div>
          </div>
        </v-col>
        <v-col md="4" sm="6" cols="12">
           <div class="service-details">
            <div class="services-icon">
              <a href="#"><i class="fas fa-camera"></i></a>
              <h4>Photography</h4>
              <p>There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration</p>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </section>

  <section class="claint-s fixed_bg">
    <v-container>
      <v-row>
        <v-col md="3" sm="3" cols="6">
          <div class="projects-completed">
            <a href="#"><i class="far fa-clipboard"></i></a>
            <h3>800+</h3>
            <p>Projects Completed</p>
          </div>
        </v-col>
        <v-col md="3" sm="3" cols="6">
          <div class="projects-completed">
            <a href="#"><i class="fas fa-users"></i></a>
            <h3>524</h3>
            <p>Happy Clients</p>
          </div>
        </v-col>
        <v-col md="3" sm="3" cols="6">
          <div class="projects-completed">
            <a href="#"><i class="fas fa-coffee"></i></a>
            <h3>654</h3>
            <p>Cup Of Tea</p>
          </div>
        </v-col>
        <v-col md="3" sm="3" cols="6">
          <div class="projects-completed">
            <a href="#"><i class="fas fa-trophy"></i></a>
            <h3>225</h3>
            <p>Awards Won</p>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </section>

  <section class="myportfolio" id="portfolio">
    <v-container>
      <v-row>
         <v-col md="12" sm="12">
          <div class="skills-heading">
            <h2>My Portfolio</h2>
            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus
              blandit massa enim. Nullam id varius nunc id varius nunc.
            </p>
          </div>
        </v-col>
        <v-col md="12" sm="12" cols="12">
          <div class="img-head">
            <v-ul class="img-head-p">
              <li @click="changeTab(1)">All</li>
              <li @click="changeTab(2)">Branding</li>
              <li @click="changeTab(3)">Web Design</li>
              <li @click="changeTab(4)">Development</li>
            </v-ul>
          </div>
        </v-col>
        <v-row v-if="step == 1">
          <v-col md="4" sm="4" cols="6">
            <div class="portfolio-img-p">
              <v-img src="../assets/1.jpg"></v-img>
            </div>
           <div class="portfolio-img-p">
              <v-img src="../assets/2.jpg"></v-img>
            </div>
          </v-col>
          <v-col md="4" sm="4" cols="6">
            <div class="portfolio-img-p">
              <v-img src="../assets/2.jpg"></v-img>
            </div>
            <div class="portfolio-img-p">
              <v-img src="../assets/2.jpg"></v-img>
            </div>
          </v-col>
          <v-col md="4" sm="4" cols="6">
            <div class="portfolio-img-p">
              <v-img src="../assets/2.jpg"></v-img>
            </div>
             <div class="portfolio-img-p">
              <v-img src="../assets/1.jpg"></v-img>
            </div>
          </v-col>
        </v-row>
        <v-row v-if="step == 2">
          <v-col md="4" sm="4" cols="6">
            <div class="portfolio-img-p">
              <v-img src="../assets/3.jpg"></v-img>
            </div>
            <div class="portfolio-img-p">
              <v-img src="../assets/4.jpg"></v-img>
            </div>
          </v-col>
          <v-col md="4" sm="4" cols="6">
            <div class="portfolio-img-p">
              <v-img src="../assets/4.jpg"></v-img>
            </div>
            <div class="portfolio-img-p">
              <v-img src="../assets/3.jpg"></v-img>
            </div>
          </v-col>
          <v-col md="4" sm="4" cols="6">
            <div class="portfolio-img-p">
              <v-img src="../assets/4.jpg"></v-img>
            </div>
            <div class="portfolio-img-p">
              <v-img src="../assets/4.jpg"></v-img>
            </div>
          </v-col>
        </v-row>
          <v-col md="4" sm="4" cols="6" v-if="step == 3">
            <div class="portfolio-img-p">
              <v-img src="../assets/5.jpg"></v-img>
            </div>
            <div class="portfolio-img-p">
              <v-img src="../assets/5.jpg"></v-img>
            </div>
            
          </v-col>
          <v-col md="4" sm="4" cols="6" v-if="step == 4"> <div class="portfolio-img-p">
            <v-img src="../assets/6.jpg"></v-img>
          </div>
          <div class="portfolio-img-p">
            <v-img src="../assets/6.jpg"></v-img>
          </div>
          </v-col>
      </v-row>
    </v-container>
  </section>

  <section class="myresume" id="resume">
    <v-container>
      <v-row>
        <v-col md="12" sm="12" cols="12">
          <div class="skills-heading">
            <h2>My Resume</h2>
            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus
              blandit massa enim. Nullam id varius nunc id varius nunc.
            </p>
          </div>
        </v-col>
        <v-col md="6" sm="6" cols="12">
          <div class="education">
            <div class="education-head">
              <i class="fas fa-graduation-cap"></i>
              <h4>Education</h4>
            </div>
            <div class="education-details">
              <div class="education-main-details">
                <div class="education-main-details-p">
                  <div class="SecondarySchool">
                    <p>2002-2006<span>Secondary School.</span></p>
                    <h3>High School</h3>
                  </div>
                  <div class="High-School">
                    <p>There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form</p>
                  </div>
                </div>
              </div>
              <div class="education-main-details">
                <div class="education-main-details-p">
                  <div class="SecondarySchool">
                    <p>2007-2010<span>National University.</span></p>
                    <h3>Bachelor Degree</h3>
                  </div>
                  <div class="High-School">
                    <p>There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form</p>
                  </div>
                </div>
              </div>
              <div class="education-main-details">
                <div class="education-main-details-p">
                  <div class="SecondarySchool">
                    <p>2010-2013<span>National University.</span></p>
                    <h3>Master Degree</h3>
                  </div>
                  <div class="High-School">
                    <p>There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </v-col>
        <v-col md="6" sm="6" cols="12">
          <div class="education">
            <div class="education-head">
             <i class="fas fa-briefcase"></i>
              <h4>Experience</h4>
            </div>
            <div class="education-details">
              <div class="education-main-details">
                <div class="education-main-details-p">
                  <div class="SecondarySchool">
                    <p>2013-2015<span>Adobe Inc.</span></p>
                    <h3>UI/UX Designer</h3>
                  </div>
                  <div class="High-School">
                    <p>There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form</p>
                  </div>
                </div>
              </div>
              <div class="education-main-details">
                <div class="education-main-details-p">
                  <div class="SecondarySchool">
                    <p>2015-2017<span>Adobe Inc.</span></p>
                    <h3>Web Development</h3>
                  </div>
                  <div class="High-School">
                    <p>There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form</p>
                  </div>
                </div>
              </div>
              <div class="education-main-details">
                <div class="education-main-details-p">
                  <div class="SecondarySchool">
                    <p>2017-2019<span>Adobe Inc.</span></p>
                    <h3>Marketing Manager</h3>
                  </div>
                  <div class="High-School">
                    <p>There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </section>

  <section class="Testimonials">
    <v-container>
      <v-row>
        <v-col md="12">
          <div class="skills-heading">
            <h2>Clients Testimonials</h2>
            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus
              blandit massa enim. Nullam id varius nunc id varius nunc.
            </p>
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="6" sm="6" cols="12">
          <div class="clients-name-details">
            <div class="clients-img-c">
              <div class="clients-pic">
                 <v-img src="../assets/c.png"></v-img>
              </div>
              <div class="clients-name-fill">
                <h4> Alden Smith</h4>
                <p>Creative Designer</p>
              </div>
            </div>
            <div class="c-details">
              <p> Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremaque laudantium, quaeillo inventore veritatis et quasi architecto explicabo. </p>
            </div>
          </div>
        </v-col>
        <v-col md="6" sm="6" cols="12">
          <div class="clients-name-details">
            <div class="clients-img-c">
              <div class="clients-pic">
                 <v-img src="../assets/cc.png"></v-img>
              </div>
              <div class="clients-name-fill">
                <h4> Lissa Castro</h4>
                <p>Developer</p>
              </div>
            </div>
            <div class="c-details">
              <p> Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremaque laudantium, quaeillo inventore veritatis et quasi architecto explicabo. </p>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </section>

  <section class="Blog" id="Blog">
    <v-container>
      <v-row>
        <v-col md="12" sm="12" cols="12">
          <div class="skills-heading">
            <h2>My Letest Blog</h2>
            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus
              blandit massa enim. Nullam id varius nunc id varius nunc.
            </p>
          </div>
        </v-col>
        <v-col md="4" sm="6" cols="12">
          <div class="card-main">
            <div class="card-main-img">
               <v-img src="../assets/8.jpg"></v-img>
            </div>
            <div class="card-img-details">
              <div class="ui-ux-heading">
                <h5><a href="#">UI/UX Design</a></h5>
                <p>Look Up At The Innovative Ways Team Work</p>
              </div>
              <div class="calender">
                <p><a href="#"> Oct 14,2020</a></p>
                <p>If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text</p>
              </div>
              <div class="readmore">
                <h5><a href="#"> Read More </a></h5>
              </div>
            </div>
          </div>
        </v-col>
        <v-col md="4" sm="6" cols="12">
          <div class="card-main">
            <div class="card-main-img">
               <v-img src="../assets/9.jpg"></v-img>
            </div>
            <div class="card-img-details">
              <div class="ui-ux-heading">
                <h5><a href="#">Branding</a></h5>
                <p>How To Create A Website For Your Business?</p>
              </div>
              <div class="calender">
                <p><a href="#"> Oct 14,2020</a></p>
                <p>If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text</p>
              </div>
              <div class="readmore">
                <h5><a href="#"> Read More </a></h5>
              </div>
            </div>
          </div>
        </v-col>
        <v-col md="4" sm="6" cols="12">
          <div class="card-main">
            <div class="card-main-img">
               <v-img src="../assets/10.jpg"></v-img>
            </div>
            <div class="card-img-details">
              <div class="ui-ux-heading">
                <h5><a href="#">Developing</a></h5>
                <p>How To Perfect You Get Free expensive Directories</p>
              </div>
              <div class="calender">
                <p><a href="#"> Oct 14,2020</a></p>
                <p>If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text</p>
              </div>
              <div class="readmore">
                <h5><a href="#"> Read More </a></h5>
              </div>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </section>

  <section class="contact-me" id="contact-me">
    <v-container>
      <v-row>
         <v-col md="12" sm="12" cols="12">
          <div class="skills-heading">
            <h2>Contact Me</h2>
            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit.
            </p>
          </div>
        </v-col>
        <v-col md="2" class="none"></v-col>
        <v-col md="8" sm="12" cols="12">
          <v-row>
            <v-col md="4" sm="4" cols="12">
              <div class="input-tag">
                 <input type="text" name="text" placeholder="Enter Name*">
              </div>
            </v-col>
            <v-col md="4" sm="4" cols="12">
              <div class="input-tag">
                 <input type="email" name="text" placeholder="Enter Email*">
              </div>
            </v-col>
            <v-col md="4" sm="4" cols="12">
              <div class="input-tag">
                 <input type="text" name="text" placeholder="Enter Subject*">
              </div>
            </v-col>
            <v-col md="12" sm="12" cols="12">
              <div class="massage-text">
                <textarea placeholder="Message*"></textarea>
              </div>
            </v-col>
            <v-col md="12" sm="12" cols="12">
              <div class="submit-button">
                <v-btn>Submit</v-btn>
              </div>
            </v-col>
            <v-col md="4" sm="4" cols="12">
              <div class="location">
                <i class="fas fa-map-marker"></i>
                <h4>ADDRESS</h4>
                <p>123 Rander Surat, Gujarat</p>
              </div>
            </v-col>
            <v-col md="4" sm="4" cols="12">
              <div class="location">
                <i class="fas fa-mobile"></i>
                <h4>PHONE</h4>
                <p>963-812-3369</p>
              </div>
            </v-col>
            <v-col md="4" sm="4" cols="12">
              <div class="location">
                <i class="fas fa-envelope"></i>
                <h4>EMAIL</h4>
                <p>annupatel7775@gmail.com</p>
              </div>
            </v-col>
          </v-row>
        </v-col>
        <v-col md="2"></v-col>
      </v-row>
    </v-container>
  </section>

  <v-footer class="footer">
    <v-container>
      <v-row>
        <v-col md="12">
        <div class="footer-logo">
          <v-img src="../assets/logo-img.png"></v-img>
        </div>
        <div class="new">
          <p>SUBSCRIBE OUR NEWSLETTER</p>
        </div>
        <div class="footer-input">
          <input type="email" name="text" placeholder="Enter Email Address">
          <v-btn> Subscribe </v-btn>
        </div>
        <div class="footer-list">
          <v-ul class="f-list">
            <li><a href="#">Home</a></li>
            <li><a href="#">About Us</a></li>
            <li><a href="#">Services</a></li>
            <li><a href="#">Experience</a></li>
            <li><a href="#">Blog</a></li>
            <li><a href="#">Contact Us</a></li>
          </v-ul>
        </div>
         <div class="social">
          <v-ul class="f-social">
            <li><a href="#"><i class="fab fa-facebook"></i></a></li>
            <li><a href="#"><i class="fab fa-instagram"></i></a></li>
            <li><a href="#"><i class="fab fa-twitter"></i></a></li>
            <li><a href="#"><i class="fab fa-youtube"></i></a></li>
            <li><a href="#"><i class="fab fa-whatsapp"></i></a></li>
          </v-ul>
        </div>
        </v-col>
      </v-row>
    </v-container>
  </v-footer>

  <v-footer class="copy-footer">
    <v-container>
      <v-row>
        <v-col md="12">
          <div class="copy">
            <p>© 2019 All Rights Reserved By <a href="#">Bestwebcreator</a></p>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </v-footer>
</template>

<script>
import logo from "../assets/logo.svg";

export default {
  
  created() {
    window.addEventListener('scroll', this.handleScroll);
  },
  destroy() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  name: "HelloWorld",
  data: () => ({
    ecosystem: [
      {
        text: "vuetify-loader",
        href: "https://github.com/vuetifyjs/vuetify-loader",
      },
      {
        text: "github",
        href: "https://github.com/vuetifyjs/vuetify",
      },
      {
        text: "awesome-vuetify",
        href: "https://github.com/vuetifyjs/awesome-vuetify",
      },
    ],
    importantLinks: [
      {
        text: "Chat",
        href: "https://community.vuetifyjs.com",
      },
      {
        text: "Made with Vuetify",
        href: "https://madewithvuejs.com/vuetify",
      },
      {
        text: "Twitter",
        href: "https://twitter.com/vuetifyjs",
      },
      {
        text: "Articles",
        href: "https://medium.com/vuetify",
      },
    ],
    logo,
    whatsNext: [
      {
        text: "Explore components",
        href: "https://vuetifyjs.com",
      },
      {
        text: "Roadmap",
        href: "https://vuetifyjs.com/introduction/roadmap/",
      },
      {
        text: "Frequently Asked Questions",
        href: "https://vuetifyjs.com/getting-started/frequently-asked-questions",
      },
    ],
    step: 1,
    display: false
  }),
  methods: {
    optionone() {
      this.display =  true;
    },
     optionclose() {
      this.display =  false;
    },
    handleScroll() {
      setTimeout(() => {
        if(window.scrollY > 0) {
          document.getElementsByClassName("main-div")[0].classList.add("nav-header");
        } else {
          document.getElementsByClassName("main-div")[0].classList.remove("nav-header");
        }
      });
    },
    changeTab(tab) {
      if(tab == 1) {
        this.step = 1;
      } else if (tab == 2) {
        this.step = 2;
      }  else if (tab == 3) {
        this.step = 3;
      }  else if (tab == 4) {
        this.step = 4;
      }
    }
  }
};
</script>


